import { render, staticRenderFns } from "./MenuItemCategory.vue?vue&type=template&id=ea409866&scoped=true&"
import script from "./MenuItemCategory.vue?vue&type=script&lang=js&"
export * from "./MenuItemCategory.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemCategory.vue?vue&type=style&index=0&id=ea409866&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea409866",
  null
  
)

export default component.exports